import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-6" }, "Change Your Password", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_modal_base = _resolveComponent("modal-base")!

  return (_openBlock(), _createBlock(_component_modal_base, {
    ref: "modal",
    title: "Change Your Password"
  }, {
    body: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_InputGroup, {
        label: "Current Password",
        "is-required": true
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.entity.currentPassword.$error}]),
            type: "password",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.currentPassword) = $event))
          }, null, 2), [
            [_vModelText, _ctx.entity.currentPassword]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_InputGroup, {
        label: "New Password",
        "is-required": true
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.entity.newPassword.$error}]),
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity.newPassword) = $event))
          }, null, 2), [
            [_vModelText, _ctx.entity.newPassword]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_InputGroup, {
        label: "Confirm New Password",
        "is-required": true,
        modelValue: _ctx.entity.confirmNewPassword,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entity.confirmNewPassword) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("input", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.entity.confirmNewPassword.$error}]),
            type: "password"
          }, null, 2)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_Button, {
        onClick: _ctx.changePassword,
        "is-loading": _ctx.isLoading
      }, {
        default: _withCtx(() => [
          _createTextVNode("Change Password")
        ]),
        _: 1
      }, 8, ["onClick", "is-loading"]),
      _createVNode(_component_Button, {
        onClick: _ctx.toggleClosed,
        type: "secondary",
        class: "btn-sm mt-4"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Cancel")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}